import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

const OnlineStatusContext = React.createContext(true);

export function OnlineStatusProvider({ children }) {
  const [onlineStatus, setOnlineStatus] = useState(true);

  useEffect(() => {
    window.addEventListener('offline', () => {
      setOnlineStatus(false);
    });
    window.addEventListener('online', () => {
      setOnlineStatus(true);
    });

    return () => {
      window.removeEventListener('offline', () => {
        setOnlineStatus(false);
      });
      window.removeEventListener('online', () => {
        setOnlineStatus(true);
      });
    };
  }, []);

  return (
    <OnlineStatusContext.Provider value={onlineStatus}>
      {children}
    </OnlineStatusContext.Provider>
  );
}

// useOnlineStatus.defaultProps = {};
OnlineStatusProvider.prototype = {
  //   children: PropTypes.oneOfType([
  //     PropTypes.arrayOf(PropTypes.node),
  //     PropTypes.node,
  //   ]).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
};

export const useOnlineStatus = () => {
  const store = useContext(OnlineStatusContext);
  return store;
};
